import styled from 'styled-components';

const AnchorStyle = styled.div`
	--pathWrapPadding: var(--sp4x) var(--sp8x);
	--anchorTitleMargin: var(--sp9x) 0 var(--sp8x) 0;
	--firstButtonMarginRight: var(--sp3x);

	--bigImageMarginBottom: var(--sp13x);

	--btnsWrapMargin: var(--sp11x) 0 0 0;
	--listLinkPadding: var(--sp2x) var(--sp3x);
	--stickyMinHeight: var(--sp100x);

	.row {
		margin: 0 calc(var(--sp5x) * -1);
	}

	.row > * {
		padding: 0 var(--sp5x);
	}

	.scroll-wrap {
		padding: var(--pathWrapPadding);
	}

	.anchor-title {
		margin: var(--anchorTitleMargin);
	}

	.content-wrap {
		.sticky-wrap {
			.sticky {
				position: sticky;
				top: 12%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				min-height: var(--stickyMinHeight);

				.links-wrap {
					.list-link {
						cursor: pointer;
						padding: var(--listLinkPadding);
						border-radius: var(--sp6x);

						&.active {
							background-color: var(--secondaryColor4);
						}
					}
				}

				.btns-wrap {
					display: flex;
					flex-wrap: wrap;
					margin: var(--btnsWrapMargin);
					gap: var(--firstButtonMarginRight);
				}
			}
		}

		.main-content {
			.description {
				.imageCont {
					margin-top: calc(var(--bigImageMarginBottom) - var(--sp2x));
					background: var(--secondaryColor4);
					border-radius: var(--sp2x);
					overflow: hidden;

					img {
						display: block;
						width: 100%;
						border-radius: var(--sp2x);
						object-fit: cover;

						&:last-child {
							margin-bottom: 0;
						}
					}
				}

				a {
					color: var(--primaryColor2);
				}

				p {
					font-size: var(--p);
					font-family: var(--helvetica);
					font-weight: 400;

					&:last-child {
						margin-bottom: 0;
					}
				}

				a {
					text-decoration: underline;
				}

				ul,
				ol {
					padding: revert;
					list-style: revert;

					li {
						font-size: var(--p);
						font-family: var(--helvetica);
						font-weight: 400;
						margin-bottom: var(--sp1x);

						&:last-child {
							margin-bottom: 0;
						}
					}
				}

				.description-title {
					font-family: var(--ping);
					font-weight: 900;
					font-size: var(--h5);
					margin-top: var(--bigImageMarginBottom);
					margin-bottom: calc(var(--bigImageMarginBottom) * 0.3);

					&:last-child {
						margin-bottom: 0;
					}
				}
			}

			.big-image {
				border-radius: var(--sp2x);
				overflow: hidden;

				span {
					img {
						border-radius: var(--sp2x);
						overflow: hidden;
					}
				}
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--pathWrapPadding: var(--sp3x) var(--sp6x);
		--anchorTitleMargin: var(--sp7x) 0 var(--sp6x) 0;
		--firstButtonMarginRight: var(--sp3x);

		--bigImageMarginBottom: var(--sp7x);

		--btnsWrapMargin: var(--sp6x) 0 0 0;
		--listLinkPadding: var(--sp2x) var(--sp3x);
		--stickyMinHeight: var(--sp75x);

		.row {
			margin: 0 calc(var(--sp4x) * -1);
		}

		.row > * {
			padding: 0 var(--sp4x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--pathWrapPadding: var(--sp3x) var(--sp6x);
		--anchorTitleMargin: var(--sp6x) 0 var(--sp5x) 0;
		--firstButtonMarginRight: var(--sp2x);

		--bigImageMarginBottom: var(--sp8x);

		--btnsWrapMargin: var(--sp5x) 0 0 0;
		--listLinkPadding: var(--sp1-5x) var(--sp3x);
		--stickyMinHeight: var(--sp60x);

		.row {
			margin: 0 calc(var(--sp3x) * -1);
		}

		.row > * {
			padding: 0 var(--sp3x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--pathWrapPadding: var(--sp2x) var(--sp5x);
		--anchorTitleMargin: var(--sp6x) 0 var(--sp5x) 0;
		--firstButtonMarginRight: var(--sp2x);

		--bigImageMarginBottom: var(--sp8x);

		--btnsWrapMargin: var(--sp5x) 0 0 0;
		--listLinkPadding: var(--sp1-5x) var(--sp3x);
		--stickyMinHeight: var(--sp56x);

		.row {
			margin: 0 calc(var(--sp3x) * -1);
		}

		.row > * {
			padding: 0 var(--sp3x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--pathWrapPadding: var(--sp2x) var(--sp4x);
		--anchorTitleMargin: var(--sp5x) 0 var(--sp4x) 0;
		--firstButtonMarginRight: var(--sp2x);

		--bigImageMarginBottom: var(--sp7x);

		--btnsWrapMargin: var(--sp5x) 0 0 0;
		--listLinkPadding: var(--sp1-5x) var(--sp3x);
		--stickyMinHeight: var(--sp50x);

		.row {
			margin: 0 calc(var(--sp2x) * -1);
		}

		.row > * {
			padding: 0 var(--sp2x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--pathWrapPadding: var(--sp2x) var(--sp4x);
		--anchorTitleMargin: var(--sp4x) 0 var(--sp3x) 0;
		--firstButtonMarginRight: var(--sp2x);

		--bigImageMarginBottom: var(--sp5x);

		--btnsWrapMargin: var(--sp3x) 0 var(--sp5x);
		--listLinkPadding: var(--sp1-5x) var(--sp3x);
		--stickyMinHeight: unset;

		.content-wrap {
			.sticky-wrap {
				.sticky {
					position: static;
				}
			}
		}

		.row {
			margin: 0 calc(var(--sp2x) * -1);
		}

		.row > * {
			padding: 0 var(--sp2x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--pathWrapPadding: var(--sp2x) var(--sp3x);
		--anchorTitleMargin: var(--sp4x) 0 var(--sp3x) 0;
		--firstButtonMarginRight: var(--sp2x);

		--bigImageMarginBottom: var(--sp5x);

		--btnsWrapMargin: var(--sp20x);
		--btnsWrapMargin: var(--sp3x) 0 var(--sp5x);
		--listLinkPadding: var(--sp1-5x) var(--sp3x);
		--stickyMinHeight: unset;

		.content-wrap {
			.sticky-wrap {
				.sticky {
					position: static;
				}
			}
		}

		.row {
			margin: 0 calc(var(--sp1x) * -1);
		}

		.row > * {
			padding: 0 var(--sp1x);
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--pathWrapPadding: var(--sp2x) var(--sp3x);
		--anchorTitleMargin: var(--sp3x) 0 var(--sp2x) 0;
		--firstButtonMarginRight: var(--sp2x);

		--bigImageMarginBottom: var(--sp5x);

		--btnsWrapMargin: var(--sp1-5x) 0 var(--sp4x);
		--listLinkPadding: var(--sp1x) var(--sp2x);
		--stickyMinHeight: unset;

		.content-wrap {
			.sticky-wrap {
				.sticky {
					position: static;
				}
			}
		}

		.row {
			margin: 0 calc(var(--sp1x) * -1);
		}

		.row > * {
			padding: 0 var(--sp1x);
		}
	}
`;

export default AnchorStyle;
